module.exports = __webpack_public_path__ + "static/media/sort.580757a0.svg";